import { render, staticRenderFns } from "./CreatorRevenueCenter.vue?vue&type=template&id=3b889bfc&scoped=true&"
import script from "./CreatorRevenueCenter.vue?vue&type=script&lang=js&"
export * from "./CreatorRevenueCenter.vue?vue&type=script&lang=js&"
import style0 from "./CreatorRevenueCenter.vue?vue&type=style&index=0&id=3b889bfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b889bfc",
  null
  
)

export default component.exports